module.exports = __webpack_public_path__ + "static/media/img21.2b37a819.jpg";